import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from './contexts/ThemeContext';
import Navbar from './components/Navbar';
import Breadcrumbs from './components/Breadcrumbs';
import Dashboard from './pages/Dashboard';
import Countries from './pages/Countries';
import CountryProfile from './pages/CountryProfile';
import Tariffs from './pages/Tariffs';
import TradeDeals from './pages/TradeDeals';
import Legislation from './pages/Legislation';
import Compare from './pages/Compare';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import EditorialStandards from './pages/EditorialStandards';
import InsightsIndex from './pages/insights/InsightsIndex';
import Methodology from './pages/insights/Methodology';
import HormuzTradeShocks from './pages/insights/HormuzTradeShocks';
import TariffsVsLegislation from './pages/insights/TariffsVsLegislation';
// Dashboard
import MiddleEastImpactDashboard from './pages/MiddleEastImpactDashboard';
// Chokepoints - Hormuz Hub
import HormuzOverview from './pages/chokepoints/hormuz/Overview';
import HormuzStatistics from './pages/chokepoints/hormuz/Statistics';
import HormuzShippingRoutes from './pages/chokepoints/hormuz/ShippingRoutes';
import HormuzHistoricalTimeline from './pages/chokepoints/hormuz/HistoricalTimeline';
import HormuzEconomicImpact from './pages/chokepoints/hormuz/EconomicImpact';
import HormuzRiskDashboard from './pages/chokepoints/hormuz/RiskDashboard';
import HormuzOilImpactCalculator from './pages/chokepoints/hormuz/OilImpactCalculator';
import HormuzLiveUpdates from './pages/chokepoints/hormuz/LiveUpdates';
import HormuzCountriesDependent from './pages/chokepoints/hormuz/CountriesDependent';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <div className="min-h-screen bg-slate-50 text-slate-900 transition-colors duration-200 dark:bg-background dark:text-on-surface">
            <Navbar />
            <div className="pt-16 lg:pl-64">
              <Breadcrumbs />
              <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/countries" element={<Countries />} />
              <Route path="/countries/:id" element={<CountryProfile />} />
              <Route path="/tariffs" element={<Tariffs />} />
              <Route path="/trade-deals" element={<TradeDeals />} />
              <Route path="/legislation" element={<Legislation />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/editorial-standards" element={<EditorialStandards />} />
              <Route path="/insights" element={<InsightsIndex />} />
              <Route path="/insights/methodology" element={<Methodology />} />
              <Route path="/insights/hormuz-trade-shocks" element={<HormuzTradeShocks />} />
              <Route path="/insights/tariffs-vs-legislation" element={<TariffsVsLegislation />} />
              {/* Middle East Impact Dashboard */}
              <Route path="/middle-east-impact-dashboard" element={<MiddleEastImpactDashboard />} />
              {/* Strait of Hormuz Hub */}
              <Route path="/strait-of-hormuz" element={<HormuzOverview />} />
              <Route path="/strait-of-hormuz/statistics" element={<HormuzStatistics />} />
              <Route path="/strait-of-hormuz/shipping-routes" element={<HormuzShippingRoutes />} />
              <Route path="/strait-of-hormuz/historical-timeline" element={<HormuzHistoricalTimeline />} />
              <Route path="/strait-of-hormuz/economic-impact" element={<HormuzEconomicImpact />} />
              <Route path="/strait-of-hormuz/risk-dashboard" element={<HormuzRiskDashboard />} />
              <Route path="/strait-of-hormuz/oil-impact-calculator" element={<HormuzOilImpactCalculator />} />
              <Route path="/strait-of-hormuz/live-updates" element={<HormuzLiveUpdates />} />
              <Route path="/strait-of-hormuz/countries-dependent" element={<HormuzCountriesDependent />} />
              </Routes>
            </div>
            <Analytics />
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
